import { SelectInput } from "~/components/SelectInput";
import { AggregateFunctions } from "~/modules/filters/types";

// // // //

/** Display labels for each aggregate function, shared across the controls that render them. */
export const AGGREGATE_FUNCTION_LABELS: Record<AggregateFunctions, string> = {
    [AggregateFunctions.Sum]: "Sum",
    [AggregateFunctions.Avg]: "Avg",
    [AggregateFunctions.Min]: "Min",
    [AggregateFunctions.Max]: "Max",
    // [AggregateFunctions.Count]: "Count",
};

const aggregateFunctionOptions = [
    AggregateFunctions.Sum,
    AggregateFunctions.Avg,
    AggregateFunctions.Min,
    AggregateFunctions.Max,
    // AggregateFunctions.Count,
].map((value) => ({
    value,
    content: {
        label: AGGREGATE_FUNCTION_LABELS[value],
    },
}));

// // // //

// ENHANCEMENT - add a mobile-ready UI for this component
export function AggregateFunctionControls(props: {
    value: AggregateFunctions;
    allowedOptions: AggregateFunctions[];
    onChange: (updated: AggregateFunctions) => void;
}) {
    const { value, allowedOptions, onChange } = props;

    return (
        <div className="flex items-center gap-2">
            <p className="text-sm font-semibold text-foreground whitespace-nowrap select-none">
                Aggregate Function
            </p>

            <SelectInput
                size="sm"
                value={value}
                onChange={(updatedValue) => {
                    // TODO - add analytics here
                    onChange(updatedValue as AggregateFunctions);
                }}
                options={aggregateFunctionOptions.filter((each) =>
                    allowedOptions.includes(each.value),
                )}
            />
        </div>
    );
}
